module.exports = __webpack_public_path__ + "img/10.5b66d6b8.jpg";